import styled from 'styled-components';

export const ArticleContent = styled.div`
  padding: 3em 0 2em 0;
`;
